import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./style.scss";

function Button({ type, color, style, size, disabled, block, onClick, title, className, children }) {
  const classes = classnames("button", className, {
    [`button--block`]: block,
    [`button--${color}`]: color,
    [`button--${style}`]: style,
    [`button--${size}`]: size !== "regular",
  });

  return (
    <button className={classes} type={type} onClick={onClick} disabled={disabled} title={title}>
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.oneOf(["submit", "button"]),
  color: PropTypes.oneOf(["primary", "secondary", "success", "warning", "danger"]),
  style: PropTypes.oneOf(["solid", "link", "ghost"]),
  size: PropTypes.oneOf(["small", "regular", "large"]),
  className: PropTypes.any,
};

Button.defaultProps = {
  disabled: false,
  block: false,
  type: "button",
  style: "solid",
  color: "primary",
  size: "regular",
  title: undefined,
  className: undefined,
};

export default Button;
